module.exports = __webpack_public_path__ + "img/ebay_logo.8092bebe.png";